export const checkAgency = (section, agency) => section?.transport?.agency?.name === agency
export const checkIsYouBike = (section) => checkAgency(section, metropia.Agency.YOU_BIKE)
export const checkIsIRent = (section) => checkAgency(section, metropia.Agency.IRENT)
